import { render, staticRenderFns } from "./GExamDetail.vue?vue&type=template&id=6da147cb&"
import script from "./GExamDetail.vue?vue&type=script&lang=ts&"
export * from "./GExamDetail.vue?vue&type=script&lang=ts&"
import style0 from "./GExamDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports